import { render, staticRenderFns } from "./SelectAssistant.vue?vue&type=template&id=2ecfc33f&scoped=true&lang=pug&"
import script from "./SelectAssistant.vue?vue&type=script&lang=js&"
export * from "./SelectAssistant.vue?vue&type=script&lang=js&"
import style0 from "./SelectAssistant.vue?vue&type=style&index=0&id=2ecfc33f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecfc33f",
  null
  
)

export default component.exports